import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { UserContext } from '../../../auth/auth0-provider-with-history';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import translate from "../../common/Dictionary";

const ShortNotice = (props) => {
    const { userData } = useContext(UserContext);

    return (
        <div className="p-2 bg-gray" align="left">
            <p>
                <FontAwesomeIcon icon={faInfoCircle} className="me-1" />
                {translate("shortNotice", userData.language)}
                <Link to="/privacypolicy" target="_blank">{translate("shortNoticeLinkEnding", userData.language)}</Link>
            </p>
        </div>
    );
}

export default ShortNotice;